import classnames from 'classnames';
import type { FC } from 'react';
import { isUkPlatform } from '@/core/settings/utils';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { translate } from '@/domains/core/localization/translate';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { useDeliveryMeta } from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';
import styles from './disclaimer.module.scss';
export const {
  freeDeliveryComplementaryInfos
} = translate({
  "freeDeliveryComplementaryInfos": "*Free shipping availability will depend on your postcode, this information will be available at checkout."
});
export const DeliveryDisclaimer: FC = () => {
  const {
    hasFreeDelivery
  } = useDeliveryMeta();
  const [isProductPageRevampEnabled] = useBooleanFlags([StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP]);
  if (!isUkPlatform()) return null;
  if (!hasFreeDelivery) return null;
  return <div className={classnames(styles.freeDeliveryInfos, {
    [styles.pdpRevamp]: isProductPageRevampEnabled
  })}>
      {freeDeliveryComplementaryInfos}
    </div>;
};